/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_Save_Hours_WeekInputs */

const en_onboarding_results_save_hours_week = /** @type {(inputs: Onboarding_Results_Save_Hours_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 hours a week`)
};

const es_onboarding_results_save_hours_week = /** @type {(inputs: Onboarding_Results_Save_Hours_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 horas a la semana`)
};

/**
* | output |
* | --- |
* | "5 hours a week" |
*
* @param {Onboarding_Results_Save_Hours_WeekInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_save_hours_week = /** @type {((inputs?: Onboarding_Results_Save_Hours_WeekInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_Save_Hours_WeekInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_save_hours_week(inputs)
	return en_onboarding_results_save_hours_week(inputs)
});